import useSharedStore from '@/presentation/store/shared';

const AUTH_ROUTES = ['auth-login', 'auth-otp', 'auth-signup', 'auth'];

const authMiddleware = (router) => {
	router.beforeEach(async (to, from) => {
		const sharedStore = useSharedStore();
		const loggedIn = sharedStore.userInformation.loggedIn;
		if (AUTH_ROUTES.includes(to.name as string) && loggedIn) {
			return '/';
		}

		const requiresAuth = to.meta?.requiresAuth;

		if (requiresAuth && !loggedIn) {
			sharedStore.redirectPathAfterLogin = from.fullPath;
			return '/auth/login';
		}
		return true;
	});
};

export default authMiddleware;
